import { render, staticRenderFns } from "./moneyInfo.vue?vue&type=template&id=f5a5b470&"
import script from "./moneyInfo.vue?vue&type=script&lang=js&"
export * from "./moneyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports